import React, { useEffect } from 'react'
import { useState } from 'react';
import ReactPlayer from 'react-player';
import movieTrailer from 'movie-trailer';
import "../Styles/TrailerMovies.css"


function TrailerTrending({TrendTittle,toggle}){
    const [video, setVideo] = useState("");
     const [videoURL, setVideoURL] = useState("");

     function handleSearch() {
        setVideo(TrendTittle)
        movieTrailer(video).then((res) => {
        setVideoURL(res);
        });
    }

    useEffect(() => {
        handleSearch()
    },[videoURL])

    return(
        <>
         <div className='container'>
         </div>
         <div className='player'>
         <h1 id={toggle ? "TrailerMovie-name-dark" : "TrailerMovie-name-light"}>{TrendTittle}</h1>
            <ReactPlayer url={videoURL} control={true} playing={true}/>
         </div>
        </>
    )

}


export default TrailerTrending;